module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_vm._v("Illustrations")])]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_c('p', {
    staticClass: "illt"
  }, [_c('b', [_vm._v("Maps")])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter07#map1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Areas of Strategic Responsibility in the Atlantic under ABC-1")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter07#map2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Areas of Strategic Responsibility in the Pacific and Far East under ABC-1")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Conclusion#map3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Areas of Strategic Responsibility, 1 December 1941")])]), _vm._v(" "), _c('p', {
    staticClass: "illt"
  }, [_c('b', [_vm._v("Figures")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter07#fig1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. U.S. Military Mission under ABC-1")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter07#fig2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. British Military Mission under ABC-1")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter08#fig3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. U.S. Special Observer Group, London, May 1941")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter08#fig4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. British Joint Staff Mission, Washington, D.C., May 1941")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter08#fig5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. British Army Staff, British Joint Staff Mission, May 1941")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter08#fig6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. British Admiralty Delegation, British Joint Staff Mission, June 1941")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f3a4b108","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/09_ListofIll.vue
// module id = 81
// module chunks = 0